/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A header configured for a remote MCP server
 */
export type RemoteMcpServerHeader = {
  /**
   * When the header was created
   */
  createdAt: Date;
  /**
   * Description of the header
   */
  description?: string | undefined;
  /**
   * The ID of the header
   */
  id: string;
  /**
   * Whether the header is required
   */
  isRequired: boolean;
  /**
   * Whether the header value is a secret
   */
  isSecret: boolean;
  /**
   * The header name
   */
  name: string;
  /**
   * When the header was last updated
   */
  updatedAt: Date;
  /**
   * The header value (redacted if secret)
   */
  value?: string | undefined;
  /**
   * Name of the inbound request header to pass through
   */
  valueFromRequestHeader?: string | undefined;
};

/** @internal */
export const RemoteMcpServerHeader$inboundSchema: z.ZodMiniType<
  RemoteMcpServerHeader,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    description: z.optional(z.string()),
    id: z.string(),
    is_required: z.boolean(),
    is_secret: z.boolean(),
    name: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    value: z.optional(z.string()),
    value_from_request_header: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "is_required": "isRequired",
      "is_secret": "isSecret",
      "updated_at": "updatedAt",
      "value_from_request_header": "valueFromRequestHeader",
    });
  }),
);

export function remoteMcpServerHeaderFromJSON(
  jsonString: string,
): SafeParseResult<RemoteMcpServerHeader, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoteMcpServerHeader$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoteMcpServerHeader' from JSON`,
  );
}
